import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services/ApiClient';
import { FiltersApiAdapter } from '../adapters/FiltersApiAdapter';
import { TeamsApiAdapter } from '../adapters/TeamsApiAdapter';
import { orderStatusFilterOptions } from '../config/orderStatusConfig';

/**
 * Hook para cargar las opciones de filtros del panel
 */
export const useFilterOptionsForPanel = () => {
  const { t } = useTranslation('invoicesOrdersModule');
  const httpClient = createHttpClient(apiClientWH);
  const filtersAdapter = new FiltersApiAdapter(httpClient);
  const teamsAdapter = new TeamsApiAdapter(httpClient);

  // Estados del pedido: sin API, mismos que Orders (orderStatusConfig)
  const orderStatusOptions = orderStatusFilterOptions.map((opt) => ({
    label: t(opt.labelKey),
    value: String(opt.status_id),
  }));

  const { data: shipmentStatuses = [] } = useQuery({
    queryKey: ['invoices-orders-filter-options', 'shipment-statuses'],
    queryFn: () => filtersAdapter.getShipmentStatuses(),
    staleTime: 5 * 60 * 1000,
  });

  const { data: shops = [] } = useQuery({
    queryKey: ['invoices-orders-filter-options', 'shops'],
    queryFn: () => filtersAdapter.getShops(),
    staleTime: 5 * 60 * 1000,
  });

  const { data: paymentMethods = [] } = useQuery({
    queryKey: ['invoices-orders-filter-options', 'payment-methods'],
    queryFn: () => filtersAdapter.getPaymentMethods(),
    staleTime: 5 * 60 * 1000,
  });

  const { data: couriers = [] } = useQuery({
    queryKey: ['invoices-orders-filter-options', 'couriers'],
    queryFn: () => filtersAdapter.getCouriers(),
    staleTime: 5 * 60 * 1000,
  });

  const { data: teams = [] } = useQuery({
    queryKey: ['invoices-orders-filter-options', 'teams'],
    queryFn: () => teamsAdapter.getTeamsChild(),
    staleTime: 5 * 60 * 1000,
  });

  const shipmentStatusOptions = shipmentStatuses.map((s) => ({
    label: s.name,
    value: String(s.id),
  }));

  const shopOptions = shops.map((s) => ({
    label: s.name,
    value: String(s.id),
  }));

  const paymentMethodOptions = paymentMethods.map((m) => ({
    label: m.name,
    value: String(m.id),
  }));

  const courierOptions = couriers.map((c) => ({
    label: c.name,
    value: String(c.id),
  }));

  const teamOptions = teams.map((t) => ({
    label: t.name,
    value: String(t.id),
  }));

  return {
    orderStatusOptions,
    shipmentStatusOptions,
    shopOptions,
    paymentMethodOptions,
    courierOptions,
    teamOptions,
  };
};
